const portfolioItems = [
  {
    title: "Radiohead",
    sinopsis:
      "Say goodbye to centralized streaming platforms and hello to a new era of community-driven music distribution.",
    desc:
      "Introducing Radiohead: a decentralized music marketplace where artists can list NFT songs and set their preferred revenue distribution, and super-fans can mint limited edition NFTs representing a stake in future revenue and exclusive access. Say goodbye to centralized streaming platforms and hello to a new era of community-driven music distribution. Deployed on Goerli and FTMtestnet for now, planning to launch on mainnet soon",
    img: "./portfolio/radio.png",
    repo: "https://github.com/jarryingnut/radiohead",
    live: "https://radioweb3.vercel.app/",
    idx: 1,
  },

  {
    title: "Blocksurance V2",
    sinopsis:
      "We provide tokenized asset insurance. Our mission is to help investors keep their DeFi investments safe",
    desc:
      "Ethereum ecosystem and DeFi has been a world of wonder for many. From Uniswap to Compound, there has been tremendous success in the space. However, there have been many high profile hacks and failures as well. The ecosystem is riddled with security problems, and so we got inspired to building the Uniswap of insurance. Blocksurance protocol provides incentivised liquidity pools, that you can use to obtain force majeure coverage for your tokenized assets. Also, you can participate in providing liquidity to the pools in exchange for profit share and rewards. We won Polygon BUIDL IT : Summer 2022 hackathon: https://devpost.com/software/blocksurance-v2",
    img: "./portfolio/Blocksurance.png",
    repo: "https://github.com/blocksurance-dao/blocksurance-v2",
    live: "https://blocksurance-mumbai.netlify.app/",
    idx: 2,
  },
  {
    title: "Fundship",
    sinopsis:
      "A decentralized crowdfunding platform for raising funds on polygon blockchain",
    desc:
      "I always wanted to build something cool and useful on the blockchain. I built this project to help people raise funds for their creative ideas and causes in a decentralized way. The frontend of the fundship is highly inspired by Kickstarter and is built with the Nextjs/Solidity/Hardhat stack. It's live on the polygon Mumbai testnet and as soon as the smart contract is audited, it will be launched on the polygon mainnet. The code is available on my GitHub and any feedback is much appreciated : )",
    img: "./portfolio/fundship.png",
    repo: "https://github.com/jarryingnut/fundship",
    live: "https://fundship.vercel.app",
    idx: 3,
  },

  {
    title: "Ethereum Speedrun",
    sinopsis: "Projects built with Scaffold-eth framework",
    desc:
      "Etherium Speed Run/BuidlGuidl is a platform/community built by Austin Griffith of the Ethereum foundation to onboard web2 developers to web3 as fast as possible using the Scaffold-eth framework. Scaffold-eth provides an off-the-shelf stack for rapid prototyping on Ethereum, giving developers access to state-of-the-art tools to learn and ship an Ethereum-based dApp quickly. I have built several dapps including a single pool DEX, decentralized staking, and Token Vendor, etc, and am still contributing to the community.",
    img: "./portfolio/scaffold-eth.png",
    repo:
      "https://buidlguidl.com/builders/0x7383Db2EFDB0cbDb37Ef60672dd95EF490bcB573",
    live:
      "https://buidlguidl.com/builders/0x7383Db2EFDB0cbDb37Ef60672dd95EF490bcB573",
    idx: 4,
  },

  {
    title: "Lount",
    sinopsis:
      "A fullstack chat application built with graphql and reactjs. Click to open",
    desc:
      "This is one of the most exciting projects I have built. It's a chat application. Backend is built with Graphql, Apollo, postgreSQl and Prisma ORM. Front end is bult with Reactjs and ChakraUI. The app is deployed on AWS EC2 and uses graphql subscriptions for sending/receiveing messages and you can react to them with emojis in real time.",
    img: "./portfolio/lountchat.png",
    repo: "https://github.com/jarryingnut/lount",
    live: "http://18.118.78.168/",
    idx: 5,
  },

  // {
  //     title: 'Gigapost',
  //     sinopsis: 'A Social Blogging platform built with MERN Stack. ',
  //     desc: 'Gigapost is a full-stack blogging application and is built with MERN stack. Tests are written in jest and cypress. The application allows you to register as a new user or login into existing account. You can create, update, delete, comment, like other people\'s posts. I have used Redux for managing state. UI is built with the help of chakraUI and the whole application is deployed on heroku.',
  //     img: './portfolio/gigapost.png',
  //     repo: 'https://github.com/jarryingnut/gigapost',
  //     live: 'https://gigapost.herokuapp.com',
  //     idx: 2
  // },

  // {
  //     title: 'Thessa',
  //     sinopsis: 'A fullstack personal management app built with firebase and react.',
  //     desc: 'Thessa is a personal management web app built with react.js for front-end and firebase for database, authentication and hosting. Styling is mostly done in SASS except for the authentication component which is styled with ChakraUI.',
  //     img: './portfolio/thessa.png',
  //     repo: 'https://github.com/jarryingnut/thessa',
  //     live: 'https://thessa-26121999.web.app',
  //     idx: 3
  // },
]

export default portfolioItems

// {
//     title:,
//     sinopsis:,
//     desc:,
//     img: './portfolio/',
//     repo:,
//     live:,
//     idx:,
// }
